import { Button } from "primereact/button";
import { OverlayPanel } from "primereact/overlaypanel";
import { useRef } from "react";

export function ColorSelect({className,inputId,value,options,onChange,onHide,defaultColor})
{
    const op = useRef();

    const mapOption=(opt)=>{
        if(opt=='auto')
        {
            return(
            <div className="surface-border border-1 hover:shadow-4 surface-0 text-center p-1" style={{width:'60px',cursor: 'pointer'}} onClick={(e)=>onClick(e,opt)}>Auto</div>
            );
        }
        return (
            <div className="shadow-1 hover:shadow-4" style={{width:'20px',height:'20px',backgroundColor:opt,cursor: 'pointer'}} onClick={(e)=>onClick(e,opt)}></div>
        );
    };
    const onClick=(e,opt)=>{   
        e.target.parentElement.value=opt;
        if(onChange) {
            onChange({
              originalEvent: e,
              value: opt,
              stopPropagation: function stopPropagation() {
                e.stopPropagation();
              },
              preventDefault: function preventDefault() {
                e.preventDefault();
              },
              target: {
                name: inputId,
                id: inputId,
                value: opt
              }
            });
          }
        op.current.toggle(e);
    };
    var color=value;
    if(value=='auto')
        color=defaultColor;
    var icon="bi-pencil-fill";
    if(color=='white')
    {
        icon="bi-pencil";
        color="gray";
    }

    return(
        <>
        <Button outlined onClick={(e) => op.current.toggle(e)}>
            <i className={icon} style={{color:color}}></i>
        </Button>
        <OverlayPanel ref={op}>
           <div id={inputId} className="flex flex-row flex-wrap gap-1" style={{width:'300px',maxHeight:'400px',overflow:'auto'}} onChange={onChange}>
            {options.map((opt)=>mapOption(opt))}
           </div>
        </OverlayPanel>
        </>
    );
}